import List from "./List/List";
import hasPermission from "/src/utils/hasPermission";
import './Home.css';
import TextInput from '/src/components/UI/TextField/TextInput';
import Field from '/src/components/UI/Field/Field';
import BlockService from '/src/features/editor/services/BlockService.js';
import { useToastDispatchContext } from "/src/layouts/toast/context/toastContext";
import { useState, useMemo, useEffect } from "react";
import Storage from "/src/utils/storage";
import capitalizeFirstLetter from "/src/utils/capitalizeFirstLetter"

function Home({ data }) {
    const [blocks, setBlocks] = useState([]);
    const [selectedBlock, setSelectedBlock] = useState(null);
    const [searchValue, setSearchValue] = useState("");

    const currentUser = Storage('local').get('user');

    const toast = useToastDispatchContext();
    const [searchState, setSearchState] = useState("idle"); // idle | success | error
    const { datasets, bots, username } = data;

    const { getBlockInformations } = BlockService;
    const sortList = (data) => {
        return data.sort((a, b) => { return new Date(b.updated_at) - new Date(a.updated_at) })
    }

    let botsSorted = sortList(bots);
    let datasetsSorted = sortList(datasets);

    const actionGetBlockInformations = async (value) => {
        if (value.length <= 3) return;
        const objectId = value.startsWith("#") ? value.slice(1) : value;

        if (!objectId) {
            setBlocks([]);
            setSelectedBlock(null);
            setSearchState("idle");
            return;
        }

        setSearchState("loading");

        const [response, error] = await getBlockInformations(objectId);

        if (error) {
            if (error.status !== 422) {
                toast.error("Error during loading", "Cannot find block data");
            }

            setBlocks([]);
            setSelectedBlock(null);
            setSearchState("error");
            return;
        }

        setBlocks(response);

        if (response.length === 1) {
            setSelectedBlock(response[0]);
        } else {
            setSelectedBlock(null);
        }

        setSearchState("success");
    };

    const blockUrl = useMemo(() => {
        if (!selectedBlock) return "";

        if (selectedBlock.is_integration) {
            return `${window.location.protocol}//${window.location.host}/company/${encodeURIComponent(selectedBlock.company_name)}/plugin/integrations/list?key=${encodeURIComponent(selectedBlock.api_key)}`;
        }

        return `${window.location.protocol}//${window.location.host}/company/${encodeURIComponent(selectedBlock.bot.company.name)}/bots/${encodeURIComponent(selectedBlock.bot.name)}#${selectedBlock.object_id}`;
    }, [selectedBlock]);

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (searchValue.length <= 3) {
                setBlocks([]);
                setSelectedBlock(null);
                setSearchState("idle");
                return;
            }

            actionGetBlockInformations(searchValue);
        }, 400);

        return () => clearTimeout(timeout);
    }, [searchValue]);
    return (
        <>

            <div className="feature-bar">
                <div className="welcome-message">
                    <div className="row">Hey {username} 👋</div>
                </div>
            </div>
            {

            }
            {currentUser.is_admin == 1 &&
                <div className="search-block-container">
                    <TextInput
                        className="full-width input-space input_search_block_home"
                        onChange={(e) => setSearchValue(e.target.value)}
                        placeholder="Search a block by its ID"
                    />
                    {searchState === "loading" && (
                        <span className="search-loader" />
                    )}
                    {searchState === "error" && (
                        <span className="search-error">
                            Block no found
                        </span>
                    )}
                    {searchState === "success" && blocks.length > 1 && !selectedBlock && (
                        <div className="search-dropdown">
                            {blocks.map((block) => {
                                if (block.is_integration) {
                                    return (
                                        <div key={`integration-${block.id}`} className="search-dropdown-item" onClick={() => setSelectedBlock(block)}>
                                            <div className="search-dropdown-title">
                                                {block.name}
                                            </div>
                                            <div className="search-dropdown-subtitle">
                                                <span style={{ color: "var(--purple)" }}> {block.company_name} </span>-<span style={{ color: "var(--orange)" }}> Integration</span>
                                            </div>
                                        </div>
                                    )
                                }

                                if (block.bot.company == null) return;
                                return (
                                    <div key={block.id} className="search-dropdown-item" onClick={() => setSelectedBlock(block)}>
                                        <div className="search-dropdown-title">
                                            {block.name}
                                        </div>
                                        <div className="search-dropdown-subtitle">
                                            <span style={{ color: "var(--purple)" }}> { block.bot.company.name} </span>-  {block.bot.name} -<span style={{ color: "var(--orange)" }}> {capitalizeFirstLetter(block.type.name)}</span>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    )}
                    {selectedBlock && selectedBlock.is_integration && (
                        <div className="search-result">
                            <span className="search-bot-name" title={selectedBlock.company_name}>
                                {selectedBlock.company_name} — Integration
                            </span>
                            <a href={blockUrl} target="_blank" rel="noopener noreferrer" className="search-link">
                                Access the integration
                            </a>
                        </div>
                    )}
                    {selectedBlock && !selectedBlock.is_integration && (
                        <div className="search-result">
                            <span className="search-bot-name" title={selectedBlock.bot.name}>
                                {selectedBlock.bot.name}
                            </span>
                            <a href={blockUrl} target="_blank" rel="noopener noreferrer" className="search-link">
                                Access the block in the editor
                            </a>
                        </div>
                    )}

                </div>

            }
            <div style={{ marginBottom: "40px" }} />


            <div className="list-container">
                <div className="row">
                    {hasPermission('view_bots') ? <List title="Bots" data={botsSorted} type='bots' {...hasPermission('create_bot') ? { url: '/bot/create' } : null} /> : null}
                </div>
                <div className="row">
                    {hasPermission('view_datasets') ? <List title="Datasets" data={datasetsSorted} type='datasets' {...hasPermission('create_dataset') ? { url: '/dataset/create' } : null} /> : null}
                </div>
            </div>
        </>
    )
}

export default Home;